import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { Store } from '@ngrx/store';
import { selectAuthUser } from '../auth.selectors';
import { switchMap } from 'rxjs/operators';
import { AppState } from '../../core.state';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';


@Injectable()
export class HttpJwtInterceptor implements HttpInterceptor {
  constructor(    
    private store: Store<AppState>
    ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {    
    return this.store.select(selectAuthUser).pipe(      
      switchMap(user => {        
        if (!request.url.startsWith('./')){
          const u = new URL(request.url);        
          if (u.host == environment.hostBackend && user && user.token){          
            request = request.clone({
              setHeaders: {
                // Cambio JWT por Token
                Authorization: `Token ${user.token}`
              }
            });
          }
        }
        return next.handle(request);
      } 
    )    
  )}
}
